<template>
  <tr >
        <td class="v-align-middle">
            {{offer.distributed_product.agency.name}}
        </td>

        <td class="v-align-middle">
            {{ offer.name }}
        </td>

        <td class="v-align-middle" v-if="offer.default_price">
            {{offer.default_price.base_price / 100 }} {{offer.default_price.currency}} / {{offer.default_price.unit_text}}
        </td>

        <td class="v-align-middle" v-else-if="notincart(this.myoffer)" >
          <input class="col-lg-6" type="number" min="0.01" step="0.01" name="price" v-model="price_specified_by_user"  >
          {{currency}} / Mois
        </td>

        <td class="v-align-middle" v-else>
          <input v-if="!updaterDataFromCart" v-model="price_specified_by_user" type="number" >
          <p v-else-if="retreiveDataFromCart" >
            {{ this.getprice / 100}} EUR / par mois
          </p>
        </td>

         <td class="v-align-middle" v-if="offer.default_price && offer.default_price.hasOwnProperty('base_quantity')">
            {{offer.default_price.base_quantity}}
         </td>

        <td class="v-align-middle" v-else>
            1
        </td>

        <!-- <td>
            <input type="date" v-model="date_available">
        </td> -->

        <td class="v-align-middle">

          <div v-if="!offer.distributed_product.agency.disabled_for_tup">
            <button v-if="notincart(this.myoffer) && this.mayupdate.length > 0" class="btn btn-danger"
              @click="$emit('crushcart', offerReady)">
              Offre incompatible avec le contenu du panier
            </button>

            <button class="btn btn-warning" v-else-if="cartCheck(this.myoffer) && this.mayupdate.length > 0">
                Offre déjà présente dans le panier
            </button>

            <button class="btn btn-complete" @click="$emit('add', offerReady)" v-else>
              <i class="fa fa-cart-arrow-down" aria-hidden="true">
              </i>
              Ajouter au panier
            </button>
          </div>

        </td>
    </tr>
</template>

<script>

export default {

  data: function() {
    return {
      price_specified_by_user:0,
      date_available:null,
      currency:"EUR",
    };
  },

  props: {
    offer: {
      required: true,
      type: Object
    },
    mayupdate: {
      required:true
    }

  },

  computed: {
    offerReady: function ()
    {
      if (this.offer.default_price)
        return ({offer:this.offer, price:this.offer.default_price.base_price, unit:"MOS", booking_date_required:this.date_available, quantity:this.offer.default_price.base_quantity})
      else
        return ({offer:this.offer, price:this.price_specified_by_user * 100, unit:"MOS", booking_date_required:this.date_available, quantity:1})
    },

    myoffer:function(){
      return this.offer
    },

    getprice:function(){
      return this.price_specified_by_user
    },

    updaterDataFromCart: function () {
      const offer_id = this.myoffer.id
      const data = this.mayupdate.filter(
        function (item) {
          return (item.id == offer_id)
        }
      )
      if (data.length == 0)
      {
        return false
      }
      else {
        return true
      }
    },

    retreiveDataFromCart:function () {
      const offer_id = this.myoffer.id
      const data = this.mayupdate.filter(
        function (item) {
          return (item.id == offer_id)
        }
      )
      if (data.length == 0)
      {
        return false
      }
      else {
        if (this.myoffer.default_price == null)
        {
          this.price_specified_by_user = data[0].price
          this.quantity_specified_by_user = data[0].quantity
        }
        return true
      }
    }

  },

  methods:
  {
    notincart:function (offer)
    {
      const res =
        this.mayupdate.find (
            function (item) {
                // console.log(item.id + " " + offer.id)
                return item.id == offer.id
            })
      // console.log(offer.id + " IS IN CART " + res)
      if (res == undefined)
        return true
      return (false)
    },

    compatibleWithCartContent:function (offer)
    {
      const res = this.mayupdate.find (
        function (item)
        {
          return item.distribution_method_id != 1
        }
      )
      if (res == undefined)
        return true
      else
        return false

    },

    cartCheck:function(offer)
    {
      const others = this.mayupdate.filter(
        function(item) {return item.distribution_method_id != 1}
      )
      if (others.length == 0)
        return true
      else {
          return false
        }
    }

  }

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// client/components/Catalog/CatalogDomItem.vue